import styled from "styled-components";

export const ContainerTimePicker = styled.div`
  position: "relative";
  width: 60px;
`;

export const InputTimeContainer = styled.input`
  width: 60px;
  font-size: 16px;
  font-family: "Exo2 Light";
  font-weight: 500;
  cursor: pointer;

  @media (min-width: 1024px) {
    font-size: 24px;
  }
`;

export const ContainerOpen = styled.div`
    position: "absolute",
    background: "#fff",
    border: "1px solid #ccc",
    padding: "10px",
    zIndex: 2,
    display: "flex",
    gap: "10px",
`;

export const ContainerPicker = styled.div`
  max-height: 150px;
  overflowy: "scroll";
`;

export const ContainerPickerHours = styled.div`
  padding: 5px;
  cursor: "pointer";
`;

export const ContainerPickerMinutes = styled.div`
  padding: 5px;
  cursor: "pointer";
`;
